import { render } from "./WarehouseAddItemForm.vue?vue&type=template&id=5f492b8f&scoped=true&ts=true"
import script from "./WarehouseAddItemForm.vue?vue&type=script&lang=ts"
export * from "./WarehouseAddItemForm.vue?vue&type=script&lang=ts"

import "./WarehouseAddItemForm.vue?vue&type=style&index=0&id=5f492b8f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f492b8f"]])

export default __exports__